import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import Home from './Home.vue'
import store from './store'
import router from './router'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: "UA-136411881-1" }
}, router);

// Vue.config.productionTip = true

new Vue({
  store,
  router,
  render: h => h(Home)
}).$mount('#app')
